(function(){
  var root=document.querySelector('.bjp');
  if(!root||root.dataset.bjpReady)return;root.dataset.bjpReady='1';
  var product=JSON.parse(root.querySelector('[data-bjp-product]').textContent);
  var inventory={};
  try{inventory=JSON.parse(root.querySelector('[data-bjp-inventory]').textContent)}catch(e){}
  var isGift=root.dataset.giftCard==='1';

  function money(c){return '£'+(c/100).toFixed(2);}
  function moneyShort(c){return (c%100===0)?'£'+(c/100):money(c);}
  function $(s,ctx){return (ctx||root).querySelector(s);}
  function $$(s,ctx){return Array.prototype.slice.call((ctx||root).querySelectorAll(s));}

  /* ---------- state ---------- */
  var optionNames=product.options||[];
  var selected=[];
  (function init(){
    var vid=parseInt($('[data-bjp-variant-id]').value,10);
    var v=product.variants.filter(function(x){return x.id===vid})[0]||product.variants[0];
    selected=[v.option1,v.option2,v.option3].slice(0,optionNames.length);
  })();
  function findVariant(sel){
    return product.variants.filter(function(v){
      return sel.every(function(s,i){return s===null||v['option'+(i+1)]===s});
    })[0]||null;
  }
  function currentVariant(){return findVariant(selected);}

  /* ---------- gallery ---------- */
  var hero=$('[data-bjp-hero]'),thumbs=$$('.bjp-thumb'),count=$('[data-bjp-count]');
  // Number of photos actually in the gallery (fewer than product.media when the
  // product is set to show only the chosen option's photo).
  var galN=$$('.bjp-hero__slide').length||1;
  var variantPhotos=root.dataset.variantPhotos==='1';
  var heroPrev=$('[data-bjp-prev]'),heroNext=$('[data-bjp-next]');
  var slideW=function(){return hero.clientWidth||1};
  function syncHeroNav(){
    if(!heroPrev||!heroNext)return;
    var i=Math.round(hero.scrollLeft/slideW());
    heroPrev.classList.toggle('is-end',i<=0);
    heroNext.classList.toggle('is-end',i>=galN-1);
  }
  // Variant-photo mode: after an option change, hold the gallery on photo 1 for
  // a moment so a glide still running from an earlier thumbnail tap can't carry
  // it away. Any touch, wheel or thumbnail tap by the customer ends the hold.
  var pinUntil=0;
  function jumpFirst(){
    hero.style.scrollSnapType='none';
    try{hero.scrollTo({left:0,behavior:'instant'})}catch(e){hero.scrollLeft=0}
    var restore=function(){hero.style.scrollSnapType=''};
    requestAnimationFrame(restore);setTimeout(restore,60);   // timer as a backstop if frames are paused
  }
  ['pointerdown','touchstart','wheel'].forEach(function(ev){hero.addEventListener(ev,function(){pinUntil=0},{passive:true})});
  hero.addEventListener('scroll',function(){
    if(pinUntil&&Date.now()<pinUntil&&hero.scrollLeft>2){jumpFirst();return}
    var i=Math.round(hero.scrollLeft/slideW());
    if(count)count.textContent=(i+1)+' / '+galN;
    thumbs.forEach(function(t,j){t.classList.toggle('is-active',j===i)});
    syncHeroNav();
  },{passive:true});
  thumbs.forEach(function(t){t.addEventListener('click',function(){
    pinUntil=0;
    hero.scrollTo({left:parseInt(t.dataset.index,10)*slideW(),behavior:'smooth'});
  })});
  function heroStep(dir){
    pinUntil=0;
    var i=Math.round(hero.scrollLeft/slideW())+dir;
    i=Math.max(0,Math.min(i,galN-1));
    hero.scrollTo({left:i*slideW(),behavior:'smooth'});
  }
  if(heroPrev)heroPrev.addEventListener('click',function(){heroStep(-1)});
  if(heroNext)heroNext.addEventListener('click',function(){heroStep(1)});
  syncHeroNav();
  function sizedSrc(src,w){return src+(src.indexOf('?')>-1?'&':'?')+'width='+w}
  // Variant-photo mode: photo 1 (hero, thumbnail, viewer) always shows the
  // chosen variant's own photo; the other variants' photos are not in the gallery.
  function setFirstPhoto(m){
    var src=m&&((m.preview_image&&m.preview_image.src)||m.src);if(!src)return;
    var alt=m.alt||product.title;
    var slide=$('.bjp-hero__slide');
    if(slide&&slide.dataset.mediaId===String(m.id))return;
    var im=slide&&slide.querySelector('img');
    if(im){im.src=sizedSrc(src,800);im.srcset=sizedSrc(src,400)+' 400w, '+sizedSrc(src,800)+' 800w, '+sizedSrc(src,1200)+' 1200w';im.alt=alt;slide.dataset.mediaId=m.id}
    var th=thumbs[0]&&thumbs[0].querySelector('img');if(th)th.src=sizedSrc(src,100);
    var zs=document.querySelector('.bjp-zoom .bjp-zoom__slide img');
    if(zs){zs.dataset.src=sizedSrc(src,1800);zs.alt=alt;if(zs.getAttribute('src'))zs.src=zs.dataset.src}
  }
  function scrollToVariantImage(v){
    if(variantPhotos){
      setFirstPhoto((v&&v.featured_media)||product.media[0]);
      // Jump (not glide) to photo 1 and hold it there briefly (see pinUntil).
      pinUntil=Date.now()+900;
      jumpFirst();
      return;
    }
    if(!v||!v.featured_media)return;
    var idx=$$('.bjp-hero__slide').findIndex(function(sl){return sl.dataset.mediaId===String(v.featured_media.id)});
    if(idx>=0)hero.scrollTo({left:idx*slideW(),behavior:'smooth'});
  }

  /* ---------- full-screen photo viewer (tap a photo) ---------- */
  (function viewer(){
    var zoom=$('[data-bjp-zoom]');if(!zoom)return;
    // Move to <body> so no theme wrapper can clip the fixed overlay; keep the
    // .bjp class on it so the stylesheet still applies.
    zoom.classList.add('bjp');document.body.appendChild(zoom);
    var track=zoom.querySelector('[data-bjp-zoom-track]'),
        slides=Array.prototype.slice.call(zoom.querySelectorAll('.bjp-zoom__slide')),
        countEl=zoom.querySelector('[data-bjp-zoom-count]'),
        closeBtn=zoom.querySelector('[data-bjp-zoom-close]'),
        prevBtn=zoom.querySelector('[data-bjp-zoom-prev]'),
        nextBtn=zoom.querySelector('[data-bjp-zoom-next]'),
        hint=zoom.querySelector('[data-bjp-zoom-hint]');
    var isOpen=false,lockY=0,opener=null,pushed=false;
    function idx(){return Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/(track.clientWidth||1))))}
    function load(i){
      [i-1,i,i+1].forEach(function(j){
        var s=slides[j];if(!s)return;var im=s.querySelector('img');
        if(im&&!im.getAttribute('src')&&im.dataset.src)im.src=im.dataset.src;
      });
    }
    function unzoom(){
      slides.forEach(function(s){s.classList.remove('is-zoomed')});
      zoom.classList.remove('is-zoomed');
      if(hint)hint.textContent='Tap the photo to zoom in';
    }
    function sync(){
      var i=idx();
      if(countEl)countEl.textContent=(i+1)+' / '+slides.length;
      if(prevBtn)prevBtn.classList.toggle('is-end',i<=0);
      if(nextBtn)nextBtn.classList.toggle('is-end',i>=slides.length-1);
      load(i);
    }
    // Programmatic jumps on a scroll-snap track glitch in Chrome unless snap
    // is switched off for the jump (same fix as the LP galleries).
    function jump(i){
      track.style.scrollSnapType='none';
      track.scrollLeft=i*track.clientWidth;
      requestAnimationFrame(function(){track.style.scrollSnapType='';sync()});
    }
    function go(dir){unzoom();jump(Math.max(0,Math.min(slides.length-1,idx()+dir)))}
    function lock(on){
      var de=document.documentElement;
      if(on){lockY=window.pageYOffset||0;de.classList.add('bjp-lock');return}
      de.classList.remove('bjp-lock');
      if(Math.abs((window.pageYOffset||0)-lockY)>1){
        try{window.scrollTo({top:lockY,left:0,behavior:'instant'})}catch(e){window.scrollTo(0,lockY)}
      }
    }
    function open(i){
      if(isOpen)return;isOpen=true;opener=document.activeElement;
      zoom.hidden=false;lock(true);unzoom();
      load(i);jump(i);
      requestAnimationFrame(function(){zoom.classList.add('is-open')});
      try{closeBtn.focus({preventScroll:true})}catch(e){}
      // The phone's back button closes the viewer instead of leaving the page.
      try{history.pushState({bjpZoom:1},'');pushed=true}catch(e){pushed=false}
    }
    function close(fromHistory){
      if(!isOpen)return;isOpen=false;
      var i=idx();unzoom();
      zoom.classList.remove('is-open');zoom.hidden=true;lock(false);
      if(i!==Math.round(hero.scrollLeft/slideW()))hero.scrollTo({left:i*slideW(),behavior:'auto'});
      if(pushed&&!fromHistory){pushed=false;try{history.back()}catch(e){}}
      pushed=false;
      if(opener&&opener.focus){try{opener.focus({preventScroll:true})}catch(e){}}
    }
    window.addEventListener('popstate',function(){if(isOpen)close(true)});
    track.addEventListener('scroll',function(){if(!zoom.classList.contains('is-zoomed'))sync()},{passive:true});
    closeBtn.addEventListener('click',function(){close(false)});
    if(prevBtn)prevBtn.addEventListener('click',function(){go(-1)});
    if(nextBtn)nextBtn.addEventListener('click',function(){go(1)});
    zoom.addEventListener('keydown',function(e){
      if(e.key==='Escape'){e.preventDefault();close(false)}
      else if(e.key==='ArrowLeft'){go(-1)}
      else if(e.key==='ArrowRight'){go(1)}
      else if(e.key==='Tab'){e.preventDefault();closeBtn.focus()}
    });
    // Tap toggles a 2.4x zoom centred on the tapped point; while zoomed the
    // photo pans with a normal finger drag (native scrolling, no gesture code).
    slides.forEach(function(s){
      var pan=s.querySelector('[data-bjp-zoom-pan]'),im=s.querySelector('img');
      if(!pan||!im)return;
      pan.addEventListener('click',function(e){
        if(s.classList.contains('is-zoomed')){unzoom();return}
        var r=im.getBoundingClientRect();
        var nw=im.naturalWidth||1,nh=im.naturalHeight||1,scale=Math.min(r.width/nw,r.height/nh);
        var dw=nw*scale,dh=nh*scale,ox=r.left+(r.width-dw)/2,oy=r.top+(r.height-dh)/2;
        var rx=Math.max(0,Math.min(1,(e.clientX-ox)/(dw||1))),ry=Math.max(0,Math.min(1,(e.clientY-oy)/(dh||1)));
        s.classList.add('is-zoomed');zoom.classList.add('is-zoomed');
        if(hint)hint.textContent='Drag to look around · tap to zoom out';
        pan.scrollLeft=rx*pan.scrollWidth-pan.clientWidth/2;
        pan.scrollTop=ry*pan.scrollHeight-pan.clientHeight/2;
      });
    });
    $$('[data-bjp-zoom-at]').forEach(function(sl){
      sl.addEventListener('click',function(){open(parseInt(sl.dataset.bjpZoomAt,10)||0)});
    });
    var zbtn=$('[data-bjp-zoom-btn]');
    if(zbtn)zbtn.addEventListener('click',function(){open(Math.round(hero.scrollLeft/slideW()))});
  })();

  /* ---------- pop-up sheets (sizing guide, message us) ---------- */
  // Shared behaviour: the pop-up lives under <body> so nothing can clip it,
  // the page behind is locked, Escape and the phone's back button close it,
  // and keyboard focus stays inside while it's open.
  function makeSheet(pop,sheet,scroller){
    pop.classList.add('bjp');document.body.appendChild(pop);
    var isOpen=false,lockY=0,opener=null,pushed=false,hideT=null;
    function lock(on){
      var de=document.documentElement;
      if(on){lockY=window.pageYOffset||0;de.classList.add('bjp-lock');return}
      de.classList.remove('bjp-lock');
      if(Math.abs((window.pageYOffset||0)-lockY)>1){
        try{window.scrollTo({top:lockY,left:0,behavior:'instant'})}catch(e){window.scrollTo(0,lockY)}
      }
    }
    function open(after){
      if(isOpen)return;isOpen=true;opener=document.activeElement;
      clearTimeout(hideT);pop.hidden=false;lock(true);
      scroller.scrollTop=0;
      // Force a layout so the slide-up transition starts from the closed
      // position without depending on animation frames (paused in some
      // background/in-app browsers).
      void sheet.offsetHeight;pop.classList.add('is-open');
      try{sheet.focus({preventScroll:true})}catch(e){}
      if(after)setTimeout(after,80);
      try{history.pushState({bjpSheet:1},'');pushed=true}catch(e){pushed=false}
    }
    function close(fromHistory){
      if(!isOpen)return;isOpen=false;
      pop.classList.remove('is-open');
      hideT=setTimeout(function(){pop.hidden=true},360);
      lock(false);
      if(pushed&&!fromHistory){pushed=false;try{history.back()}catch(e){}}
      pushed=false;
      if(opener&&opener.focus){try{opener.focus({preventScroll:true})}catch(e){}}
    }
    window.addEventListener('popstate',function(){if(isOpen)close(true)});
    pop.addEventListener('keydown',function(e){
      if(e.key==='Escape'){e.preventDefault();close(false);return}
      if(e.key!=='Tab')return;
      var f=$$('button,input:not([type="hidden"]),textarea,a[href]',sheet).filter(function(el){return !el.disabled&&el.offsetParent!==null});
      if(!f.length)return;
      var first=f[0],last=f[f.length-1];
      if(e.shiftKey&&(document.activeElement===first||document.activeElement===sheet)){e.preventDefault();last.focus()}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
    });
    return {open:open,close:close};
  }
  // Both pop-ups use Shopify's contact form. After a send (or an error)
  // Shopify reloads the page and BOTH forms render the result, so note which
  // one sent it and reopen only that one. Falls back to the #form-id in the
  // address, then to "Message us".
  var sizePopEl=$('[data-bjp-size]'),msgPopEl=$('[data-bjp-msg]');
  var contactFrom=null;
  try{contactFrom=sessionStorage.getItem('bjpContactFrom');sessionStorage.removeItem('bjpContactFrom')}catch(e){}
  if(contactFrom!=='msg'&&contactFrom!=='size'){
    contactFrom=location.hash==='#bjp-size-form'?'size':location.hash==='#bjp-msg-form'?'msg':null;
  }
  if(contactFrom==='msg'&&!msgPopEl)contactFrom='size';
  if(contactFrom==='size'&&!sizePopEl)contactFrom='msg';
  if(!contactFrom)contactFrom=msgPopEl?'msg':'size';
  function noteContact(form,key){
    if(form)form.addEventListener('submit',function(){try{sessionStorage.setItem('bjpContactFrom',key)}catch(e){}});
  }
  // Drop ?contact_posted=true so a refresh shows the normal page again.
  function clearPosted(){
    try{
      var u=new URL(location.href);
      if(u.searchParams.has('contact_posted')){u.searchParams.delete('contact_posted');history.replaceState(history.state,'',u.pathname+u.search)}
    }catch(e){}
  }

  /* ---------- sizing pop-up (bracelets) ---------- */
  (function sizing(){
    var pop=sizePopEl;if(!pop)return;
    var sheet=pop.querySelector('[data-bjp-size-sheet]'),scroller=pop.querySelector('[data-bjp-size-scroll]'),
        wrist=pop.querySelector('[data-bjp-size-wrist]'),result=pop.querySelector('[data-bjp-size-result]'),
        idealEl=pop.querySelector('[data-bjp-size-ideal]'),noteEl=pop.querySelector('[data-bjp-size-note]'),
        msg=pop.querySelector('[data-bjp-size-msg]'),wristField=pop.querySelector('[data-bjp-size-wrist-field]'),
        help=pop.querySelector('[data-bjp-size-help]');
    var title=pop.getAttribute('data-product-title')||'';
    var photo=pop.querySelector('[data-bjp-size-img]'),optField=pop.querySelector('[data-bjp-size-opt]'),
        priceField=pop.querySelector('[data-bjp-size-price]'),pageField=pop.querySelector('[data-bjp-size-page]'),
        formBtn=pop.querySelector('[data-bjp-size-formbtn]'),formWrap=pop.querySelector('[data-bjp-size-formwrap]');
    var s=makeSheet(pop,sheet,scroller);

    // The chosen metal (Charlie, 17 Oct): the photo and the email's
    // Option / Price / Page follow it, so a reply can quote the right price.
    function syncVariant(){
      var v=currentVariant();if(!v)return;
      if(photo&&v.featured_image&&v.featured_image.src){
        photo.src=v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i,'$1?width=480&');
        photo.removeAttribute('srcset');
      }
      if(optField)optField.value=v.title;
      if(priceField)priceField.value=moneyShort(v.price);
      if(pageField)pageField.value=location.origin+location.pathname+'?variant='+v.id;
    }
    $$('[data-bjp-size-open]').forEach(function(b){b.addEventListener('click',function(){syncVariant();s.open()})});
    $$('[data-bjp-size-close]',pop).forEach(function(b){b.addEventListener('click',function(){s.close(false)})});
    noteContact(pop.querySelector('form'),'size');

    // Wrist + 2cm calculator (Annabel's tip), in half centimetres.
    function parseCm(v){var n=parseFloat(String(v||'').replace(',','.').replace(/[^\d.]/g,''));return isNaN(n)?null:n}
    function half(n){return Math.round(n*2)/2}
    function cm(n){return String(half(n)).replace(/\.0$/,'')+'cm'}
    // The form's wrist field (visible) follows the calculator until she edits it.
    if(wristField)wristField.addEventListener('input',function(){wristField.dataset.touched='1'});
    function setWristField(v){if(wristField&&!wristField.dataset.touched)wristField.value=v}
    function calc(){
      var w=parseCm(wrist.value);
      if(w===null){result.hidden=true;setWristField('');return}
      result.hidden=false;
      if(w<10||w>25){
        idealEl.textContent='–';
        noteEl.textContent='Please check that measurement. It should be in centimetres, for example 15.5.';
        setWristField('');
        return;
      }
      var ideal=half(w+2);
      idealEl.textContent=cm(ideal);
      // Facts only, no fit verdict (Charlie, 17 Oct).
      noteEl.textContent="Our bracelets are approx. 18cm. If you'd like a different length, message us and we can make yours to size.";
      setWristField(cm(w));
    }
    wrist.addEventListener('input',calc);
    $$('[data-bjp-size-step]',pop).forEach(function(b){
      b.addEventListener('click',function(){
        var w=parseCm(wrist.value);
        w=(w===null)?15:w+parseFloat(b.getAttribute('data-bjp-size-step'));
        w=Math.max(10,Math.min(25,half(w)));
        wrist.value=String(w).replace(/\.0$/,'');
        calc();
      });
    });

    // The message form sits behind "Message us about sizing". It opens straight
    // away if this form has just sent (thank-you) or come back with an error.
    function showForm(focus){
      if(!formWrap)return;
      formWrap.hidden=false;
      if(formBtn){formBtn.hidden=true;formBtn.setAttribute('aria-expanded','true')}
      if(focus){
        var first=formWrap.querySelector('input:not([type=hidden]),textarea');
        if(first){try{first.focus({preventScroll:true})}catch(e){}}
        scroller.scrollTop=Math.max(0,formWrap.offsetTop-90);
      }
    }
    if(formWrap&&formBtn&&!pop.querySelector('[data-bjp-size-posted]')){
      formWrap.hidden=true;formBtn.hidden=false;formBtn.setAttribute('aria-expanded','false');
      formBtn.addEventListener('click',function(){showForm(true)});
    }

    // Reopen on the thank-you / error message if this form sent it.
    if(pop.querySelector('[data-bjp-size-posted]')&&contactFrom==='size'){
      clearPosted();
      s.open(function(){if(help)scroller.scrollTop=Math.max(0,help.offsetTop-12)});
    }
  })();

  /* ---------- "Message us" pop-up (all products) ---------- */
  (function messageUs(){
    var pop=msgPopEl;if(!pop)return;
    var s=makeSheet(pop,pop.querySelector('[data-bjp-msg-sheet]'),pop.querySelector('[data-bjp-msg-scroll]'));
    $$('[data-bjp-msg-open]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();s.open()})});
    $$('[data-bjp-msg-close]',pop).forEach(function(b){b.addEventListener('click',function(){s.close(false)})});
    noteContact(pop.querySelector('form'),'msg');
    if(pop.querySelector('[data-bjp-msg-posted]')&&contactFrom==='msg'){clearPosted();s.open()}
  })();

  /* ---------- welcome 10% (self-contained; Klaviyo client API) ---------- */
  var welcomeWrap=$('[data-bjp-welcome]');
  var WELCOME={pct:10,code:'WELCOME10',company:'YfSSkF',list:'XJ6k7N',source:'Product Page',
    copyTpl:"We'll email your code — it would bring this to {discounted}.",
    done1:"It's on its way to {email}",
    done2:"Enter {code} at checkout. We'll send a little note when new beads arrive, and you can unsubscribe any time.",
    bdayInvalid:'Please write your birthday as DD/MM.'};
  function wTpl(s,vars){return s.replace(/\{(\w+)\}/g,function(_,k){return vars[k]!=null?vars[k]:''});}
  function wEsc(s){var d=document.createElement('div');d.textContent=s;return d.innerHTML;}
  function updateWelcomeCopy(){
    if(!welcomeWrap)return;
    var copy=welcomeWrap.querySelector('[data-bjp-welcome-copy]');if(!copy)return;
    var v=currentVariant();if(!v)return;
    var after=Math.round(v.price*(100-WELCOME.pct)/100);
    copy.innerHTML=wTpl(wEsc(WELCOME.copyTpl),{discounted:'<strong>'+money(after)+'</strong>'});
  }
  // "DD/MM" -> ISO date; year is current (Klaviyo's birthday trigger ignores
  // it), 29/02 needs a leap year.
  function parseBirthday(raw){
    var m=String(raw||'').trim().match(/^(\d{1,2})\s*[\/\-. ]?\s*(\d{1,2})$/);
    if(!m)return null;
    var d=parseInt(m[1],10),mo=parseInt(m[2],10);
    if(mo<1||mo>12||d<1)return null;
    if(d>[31,29,31,30,31,30,31,31,30,31,30,31][mo-1])return null;
    var year=new Date().getFullYear();
    if(mo===2&&d===29){while(!(year%4===0&&(year%100!==0||year%400===0)))year--;}
    var pad=function(x){return (x<10?'0':'')+x};
    return {iso:year+'-'+pad(mo)+'-'+pad(d)};
  }
  // Klaviyo client subscribe — public company id only, JSON:API content type
  // required. Explicit consent block or the profile is never opted in.
  function klaviyoSubscribe(email,birthday){
    var attrs={email:email,subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}};
    if(birthday)attrs.properties={'Birthday':birthday.iso};
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(WELCOME.company),{
      method:'POST',
      headers:{'Content-Type':'application/vnd.api+json','revision':'2026-07-15'},
      body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:WELCOME.source,profile:{data:{type:'profile',attributes:attrs}}},relationships:{list:{data:{type:'list',id:WELCOME.list}}}}})
    }).then(function(r){
      if(!r.ok&&r.status!==202)throw new Error('klaviyo '+r.status);
      return r;
    });
  }
  if(welcomeWrap)(function(){
        // Don't offer the first-order code to people we can already tell are
    // known: a previous signup on this device (localStorage), an arrival
    // from a Klaviyo email (_kx link parameter), or a Klaviyo cookie that
    // identifies this browser as an existing profile. Best-effort only —
    // the WELCOME10 discount's own eligibility rules are the hard gate.
    function knownProfile(){
      try{
        if(localStorage.getItem('bjpWelcomeHide'))return true;
        if(location.search.indexOf('_kx=')>-1){localStorage.setItem('bjpWelcomeHide','1');return true;}
        var m=document.cookie.match(/(?:^|; )__kla_id=([^;]+)/);
        if(m){
          var d=JSON.parse(atob(decodeURIComponent(m[1])));
          if(d&&(d.$exchange_id||d.$email)){localStorage.setItem('bjpWelcomeHide','1');return true;}
        }
      }catch(e){}
      return false;
    }
    if(knownProfile()){welcomeWrap.hidden=true;return;}
    var openBtn=welcomeWrap.querySelector('[data-bjp-welcome-open]'),
        panel=welcomeWrap.querySelector('[data-bjp-welcome-panel]'),
        form=welcomeWrap.querySelector('[data-bjp-welcome-form]'),
        done=welcomeWrap.querySelector('[data-bjp-welcome-done]'),
        errEl=welcomeWrap.querySelector('[data-bjp-welcome-err]');
    var bday=welcomeWrap.querySelector('[data-bjp-bday]');
    // Klaviyo's own "do we know this browser?" check, once its script has
    // loaded: catches subscribers the cookie test above can miss. Only hides
    // the strip if nobody has opened it yet on this page.
    function klaviyoKnown(){
      try{
        var kl=window.klaviyo;
        if(!kl||typeof kl.isIdentified!=='function')return;
        Promise.resolve(kl.isIdentified()).then(function(known){
          if(known===true&&panel.hidden&&done.hidden){
            welcomeWrap.hidden=true;
            try{localStorage.setItem('bjpWelcomeHide','1')}catch(e){}
          }
        }).catch(function(){});
      }catch(e){}
    }
    if(document.readyState==='complete')klaviyoKnown();
    else window.addEventListener('load',klaviyoKnown);
    if(bday){
      // Auto-insert the slash — iOS numeric keypads have no "/" key.
      bday.addEventListener('input',function(e){
        var deleting=e.inputType&&e.inputType.indexOf('delete')===0;
        var digits=this.value.replace(/\D/g,'').slice(0,4);
        var out=digits;
        if(digits.length>2)out=digits.slice(0,2)+'/'+digits.slice(2);
        else if(digits.length===2&&!deleting)out=digits+'/';
        this.value=out;
      });
    }
    // Tap-to-copy pill for the discount code in the success box.
    var copyBtn=welcomeWrap.querySelector('[data-bjp-welcome-copy-btn]');
    if(copyBtn){
      copyBtn.querySelector('.code').textContent=WELCOME.code;
      copyBtn.addEventListener('click',function(){
        var lbl=copyBtn.querySelector('[data-bjp-welcome-copy-lbl]');
        function okFx(){
          lbl.textContent='Copied';lbl.classList.add('is-copied');
          setTimeout(function(){lbl.textContent='Copy code';lbl.classList.remove('is-copied')},2200);
        }
        function fallback(){
          var ta=document.createElement('textarea');ta.value=WELCOME.code;
          ta.style.position='fixed';ta.style.opacity='0';
          document.body.appendChild(ta);ta.select();
          try{document.execCommand('copy');okFx()}catch(e){}
          document.body.removeChild(ta);
        }
        if(navigator.clipboard&&navigator.clipboard.writeText){
          navigator.clipboard.writeText(WELCOME.code).then(okFx).catch(fallback);
        }else{fallback()}
      });
    }
    openBtn.addEventListener('click',function(){
      openBtn.hidden=true;panel.hidden=false;updateWelcomeCopy();
      var inp=panel.querySelector('input');if(inp)inp.focus();
    });
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var input=form.querySelector('input[type="email"]');
      var email=(input.value||'').trim();
      errEl.hidden=true;
      if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){
        errEl.textContent='That email address does not look right.';errEl.hidden=false;return;
      }
      var bdayRaw=bday?(bday.value||'').trim():'';
      var birthday=bdayRaw?parseBirthday(bdayRaw):null;
      if(bdayRaw&&!birthday){errEl.textContent=WELCOME.bdayInvalid;errEl.hidden=false;bday.focus();return;}
      var btn=form.querySelector('button');btn.disabled=true;
      klaviyoSubscribe(email,birthday).then(function(){
        panel.hidden=true;done.hidden=false;
                try{localStorage.setItem('bjpWelcomeHide','1')}catch(e){}
        welcomeWrap.querySelector('[data-bjp-welcome-done-1]').textContent=wTpl(WELCOME.done1,{email:email});
        welcomeWrap.querySelector('[data-bjp-welcome-done-2]').innerHTML=wTpl(wEsc(WELCOME.done2),{code:'<strong>'+wEsc(WELCOME.code)+'</strong>'});
        // The panel above just collapsed, so make sure the success box is
        // actually on screen.
        setTimeout(function(){done.scrollIntoView({behavior:'smooth',block:'center'})},60);
      }).catch(function(){
        btn.disabled=false;
        errEl.textContent='We could not save that just now — please try again.';errEl.hidden=false;
      });
    });
  })();

  /* ---------- render on selection change ---------- */
  var priceEl=$('[data-bjp-price]'),wasEl=$('[data-bjp-was]'),klarnaEl=$('[data-bjp-klarna]'),stockEl=$('[data-bjp-stock]'),
      atc=$('[data-bjp-atc]'),atcLabel=$('[data-bjp-atc-label]'),idInput=$('[data-bjp-variant-id]'),
      stickyPrice=$('[data-bjp-sticky-price]'),stickyVar=$('[data-bjp-sticky-variant]'),stickyImg=$('[data-bjp-sticky-img]'),
      stickyAtc=$('[data-bjp-sticky-atc]');

  function isLow(v){
    var inv=v&&inventory[String(v.id)];
    return !!(v&&v.available&&inv&&inv.managed&&inv.policy!=='continue'&&inv.qty>0&&inv.qty<=3);
  }
  function stockTextFor(v){
    if(!v||!v.available)return 'Sold out';
    if(isLow(v))return 'Only '+inventory[String(v.id)].qty+' left — dispatched in 1–2 working days';
    return 'In stock — dispatched in 1–2 working days';
  }

  /* ---------- estimated delivery (UK time). Dispatch = today if it's a
     working day (Mon–Fri, not a UK bank holiday) before the cut-off hour,
     otherwise the next working day. Delivery = dispatch + ship_min..ship_max
     Royal Mail delivery days (Mon–Sat, not bank holidays): tracked orders
     Apr–Oct 2026 arrived 2 delivery days after dispatch (Mon→Wed, Thu→Sat,
     Fri→Mon), occasionally 3, almost never 1. All editor settings. ---------- */
  var etaLine=$('[data-bjp-eta-line]'),etaEl=$('[data-bjp-eta]');
  var etaCfg=(root.dataset.eta||'').split(',').map(function(x){return parseInt(x,10)});
  var BANK=['2026-12-25','2026-12-28','2027-01-01','2027-03-26','2027-03-29','2027-05-03','2027-05-31','2027-08-30','2027-12-27','2027-12-28','2028-01-03','2028-04-14','2028-04-17','2028-05-01','2028-05-29','2028-08-28','2028-12-25','2028-12-26'];
  var DAYS=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],MONTHS=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function ymd(d){var m=d.getMonth()+1,x=d.getDate();return d.getFullYear()+'-'+(m<10?'0':'')+m+'-'+(x<10?'0':'')+x}
  function addWorkingDays(from,n){
    var d=new Date(from.getFullYear(),from.getMonth(),from.getDate());
    while(n>0){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==0&&w!==6&&BANK.indexOf(ymd(d))<0)n--}
    return d;
  }
  // Royal Mail doesn't deliver on Sundays, bank holidays or 26 December
  // (even when Boxing Day falls on a Saturday).
  function addDeliveryDays(from,n){
    var d=new Date(from.getFullYear(),from.getMonth(),from.getDate());
    while(n>0){d.setDate(d.getDate()+1);if(d.getDay()!==0&&BANK.indexOf(ymd(d))<0&&!(d.getMonth()===11&&d.getDate()===26))n--}
    return d;
  }
  function isWorkingDay(d){var w=d.getDay();return w!==0&&w!==6&&BANK.indexOf(ymd(d))<0}
  function ukNow(){
    // The shopper's device may not be on UK time; the dispatch cut-off is.
    try{
      var p={};new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/London',year:'numeric',month:'numeric',day:'numeric',hour:'numeric',hourCycle:'h23'})
        .formatToParts(new Date()).forEach(function(x){p[x.type]=x.value});
      return {date:new Date(+p.year,+p.month-1,+p.day),hour:+p.hour};
    }catch(e){var n=new Date();return {date:new Date(n.getFullYear(),n.getMonth(),n.getDate()),hour:n.getHours()}}
  }
  function etaText(){
    if(etaCfg.length<3||etaCfg.slice(0,3).some(isNaN))return '';
    var now=ukNow(),cutoff=etaCfg[0],min=etaCfg[1],max=Math.max(etaCfg[1],etaCfg[2]);
    // Christmas rush (24 Nov–24 Dec): last year's dispatch kept pace, but there
    // is no Royal Mail delivery data for that period, so widen the latest date.
    var mo=now.date.getMonth(),dy=now.date.getDate();
    if(!isNaN(etaCfg[3])&&((mo===10&&dy>=24)||(mo===11&&dy<=24)))max+=etaCfg[3];
    var dispatch=(isWorkingDay(now.date)&&now.hour<cutoff)?now.date:addWorkingDays(now.date,1);
    var a=addDeliveryDays(dispatch,min),b=addDeliveryDays(dispatch,max);
    var fa=DAYS[a.getDay()]+' '+a.getDate(),fb=DAYS[b.getDay()]+' '+b.getDate()+' '+MONTHS[b.getMonth()];
    if(a.getTime()===b.getTime())return fb;
    if(a.getMonth()!==b.getMonth())fa+=' '+MONTHS[a.getMonth()];
    return fa+' – '+fb;
  }
  var etaStr=etaText();

  /* ---------- free UK delivery (£75, same rule as the cart bar) ---------- */
  var FD=parseInt(root.dataset.fdThreshold||'7500',10)||7500;
  var cartTotal=parseInt(root.dataset.cartTotal||'0',10)||0;
  var cartVariants=(root.dataset.cartVariants||'').split(',').filter(Boolean);
  function orderBase(v){
    if(!v)return cartTotal;
    return cartTotal+(cartVariants.indexOf(String(v.id))>-1?0:v.price);
  }
  function renderDelivery(){
    var v=currentVariant();
    if(etaLine){
      var on=!!(etaStr&&v&&v.available);
      if(on&&etaEl)etaEl.textContent=etaStr;
      etaLine.hidden=!on;
    }
    renderStackNudge();
  }
  function setCart(cart){
    if(!cart)return;
    cartTotal=cart.total_price||0;
    cartVariants=(cart.items||[]).map(function(i){return String(i.variant_id)});
    renderDelivery();
  }
  // Back/forward cache can restore an old bag total — refresh it.
  window.addEventListener('pageshow',function(e){
    if(e.persisted)fetch('/cart.js').then(function(r){return r.json()}).then(setCart).catch(function(){});
  });

  function renderChipStates(){
    $$('[data-bjp-chip]').forEach(function(chip){
      var pos=parseInt(chip.dataset.opt,10)-1,val=chip.dataset.value;
      var test=selected.slice();test[pos]=val;
      var v=findVariant(test),pe=$('[data-bjp-chipprice]',chip);
      var cur=currentVariant();
      if(pe)pe.textContent=(v&&v.available&&cur&&v.price!==cur.price)?' '+moneyShort(v.price):'';
      chip.classList.toggle('is-selected',selected[pos]===val);
      chip.classList.toggle('is-oos',!v||!v.available);
      chip.setAttribute('aria-checked',selected[pos]===val?'true':'false');
    });
  }
  function renderEngravingBoxes(){
    if(root.dataset.engravingMode!=='discs-option')return;
    var pos=optionNames.indexOf('Initial discs');if(pos<0)return;
    var n=parseInt(selected[pos],10)||1;
    var row=$('[data-bjp-engraving-row]');if(!row)return;
    var cells=$$('.bjp-engraving__cell',row);
    if(cells.length!==n){
      var vals=cells.map(function(f){return $('input',f).value});
      row.innerHTML='';
      for(var i=1;i<=n;i++){
        var d=document.createElement('div');d.className='bjp-engraving__cell';
        d.innerHTML='<label class="bjp-engraving__cell-label" for="bjp-eng-dyn-'+i+'">Disc '+i+'</label>'+
          '<input id="bjp-eng-dyn-'+i+'" class="bjp-input bjp-input--initial" type="text" name="properties[Initial disc '+i+' engraving]" maxlength="1" placeholder="A" autocomplete="off" data-bjp-engraving-input value="'+(vals[i-1]||'').replace(/"/g,'&quot;')+'">';
        row.appendChild(d);
      }
    }
    if(typeof fitEngraving==='function')fitEngraving();
  }
  function render(){
    var v=currentVariant();
    optionNames.forEach(function(n,i){
      var ve=$('[data-bjp-optvalue="'+(i+1)+'"]');if(ve)ve.textContent=selected[i]||'';
      var se=$('[data-bjp-optselect="'+(i+1)+'"]');if(se&&se.value!==selected[i])se.value=selected[i];
    });
    renderChipStates();renderEngravingBoxes();
    if(v){
      idInput.value=v.id;
      priceEl.textContent=money(v.price);
      if(wasEl){
        if(v.compare_at_price&&v.compare_at_price>v.price){wasEl.textContent=money(v.compare_at_price);wasEl.hidden=false}
        else{wasEl.hidden=true}
      }
      if(klarnaEl)klarnaEl.textContent='or 3 payments of '+money(Math.round(v.price/3))+' with Klarna';
      if(stockEl){stockEl.textContent=stockTextFor(v);stockEl.classList.toggle('is-low',isLow(v))}
      if(v.available){
        atc.disabled=false;atc.classList.remove('is-notify');
        atcLabel.textContent='Add to bag';
        if(stickyAtc)stickyAtc.textContent='Add to bag';
      }else{
        atc.disabled=false;atc.classList.add('is-notify');
        atcLabel.textContent='Join the waitlist';
        if(stickyAtc)stickyAtc.textContent='Notify me';
      }
      if(stickyPrice)stickyPrice.textContent=money(v.price);
      if(stickyVar)stickyVar.textContent=(product.variants.length>1&&!isGift)?v.title:'';
      if(stickyImg&&v.featured_image)stickyImg.src=v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i,'$1?width=100&');
      scrollToVariantImage(v);
      updateWelcomeCopy();
      try{var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u)}catch(e){}
    }else{
      atc.disabled=true;atc.classList.remove('is-notify');atcLabel.textContent='Unavailable';if(stockEl){stockEl.textContent='Unavailable in this combination';stockEl.classList.remove('is-low')}
    }
    updateStackMatch();renderDelivery();
  }

  $$('[data-bjp-chip]').forEach(function(chip){
    chip.addEventListener('click',function(){
      selected[parseInt(chip.dataset.opt,10)-1]=chip.dataset.value;render();
    });
  });
  $$('[data-bjp-optselect]').forEach(function(sel){
    sel.addEventListener('change',function(){
      selected[parseInt(sel.dataset.bjpOptselect,10)-1]=sel.value;render();
    });
  });
  $$('[data-bjp-sizelink]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var acc=document.getElementById(btn.getAttribute('data-bjp-sizelink'));if(!acc)return;
      acc.open=true;
      var top=acc.getBoundingClientRect().top+(window.pageYOffset||0)-90;
      try{window.scrollTo({top:top,behavior:'smooth'})}catch(e){window.scrollTo(0,top)}
    });
  });
  /* ---------- engraving: the words box, limits, no emojis, preview on the charm (17 Oct) ----------
     Driven by the "Engraving charm" block that lists this product (theme editor):
     the snippet passes its numbers on [data-bjp-engrave]. Words mode: one box;
     return starts a new line, a line that is too long wraps at a space, up to
     the charm's line limit; emojis are dropped as typed. The lines become
     "Engraving" (one line) or "Engraving (line 1)…" on the order. Discs mode:
     one letter per disc, drawn on a row of disc photos. Without a charm block
     the old 12-character box works exactly as before. */
  var eng=$('[data-bjp-engrave]'),engMain=$('[data-bjp-eng-main]');
  function engNum(a,d){var v=parseFloat(eng&&eng.getAttribute(a));return isNaN(v)?d:v}
  var engCfg={
    lines:engNum('data-lines',1),one:engNum('data-chars-one',12),
    limits:(eng&&eng.getAttribute('data-limits')||'9,8,7,6').split(',').map(function(n){return parseInt(n,10)||8}),
    area:(eng&&eng.getAttribute('data-area')||'11,17,77,67').split(',').map(parseFloat),
    shape:(eng&&eng.getAttribute('data-shape'))||'heart',
    margin:engNum('data-margin',10)/100,pos1:engNum('data-pos1',42)/100,pos2:engNum('data-pos2',46)/100,
    max:engNum('data-max',24),min:engNum('data-min',6)
  };
  var engState={tooSmall:false};
  // How wide the charm's flat face is at a given depth (0 = top of the face,
  // 1 = bottom), as a share of its widest point. A heart is widest a third of
  // the way down and narrows to the point; nothing fits across the notch at the top.
  function engProfile(t){
    if(t<=0||t>=1)return 0;
    if(engCfg.shape==='round')return 2*Math.sqrt(t*(1-t));
    if(engCfg.shape==='rectangle')return 1;
    var p=[[0,0],[0.12,0],[0.16,0.9],[0.25,1],[0.4,0.97],[0.56,0.82],[0.74,0.55],[0.88,0.29],[0.96,0.1],[1,0]];
    for(var i=1;i<p.length;i++)if(t<=p[i][0]){var a=p[i-1],b=p[i];return a[1]+(b[1]-a[1])*(t-a[0])/(b[0]-a[0])}
    return 0;
  }
  // Lays the lines out inside the flat face and finds the largest letters that
  // keep every line inside the face's width at its own depth, and the whole
  // block inside the face's height, with the safety gap all round. The size
  // changes where the lines sit, so it settles over a few passes.
  function engPlace(boxEl,spans,lines,size){
    var a=engCfg.area,areaW=size*a[2]/100,areaH=size*a[3]/100,m=engCfg.margin,N=lines.length,pitch=1.12;
    boxEl.style.left=a[0]+'%';boxEl.style.top=a[1]+'%';boxEl.style.width=a[2]+'%';boxEl.style.height=a[3]+'%';
    var fs0=size*engCfg.max/100,minFs=size*engCfg.min/100;
    boxEl.style.fontSize=fs0+'px';
    var w0=spans.map(function(s,i){return lines[i]?s.offsetWidth:0});
    var pos=N>1?engCfg.pos2:engCfg.pos1,avail=Math.min(pos-m,1-m-pos)*areaH;
    // Does a letter size work? Every line must fit the face's width at the depth
    // it lands at with that size, and the block must fit the height.
    function ok(f){
      if(N*pitch*f/2>avail)return false;
      for(var i=0;i<N;i++){
        var t=pos+(i-(N-1)/2)*pitch*f/areaH,e=0.25*f/areaH;
        // The letters reach about a quarter of the size above and below the line's
        // centre, so the face must be wide enough there too — a heart narrows
        // quickly towards the point and the notch, and that is where corners poke out.
        var prof=Math.min(engProfile(t),engProfile(t-e),engProfile(t+e));
        if(w0[i]*f/fs0>areaW*prof*(1-2*m))return false;
      }
      return true;
    }
    // Largest size that works, found by halving between the floor and the largest.
    var fs=fs0;
    if(!ok(fs)){
      var lo=minFs*0.3,hi=fs0;
      for(var it=0;it<16;it++){var mid=(lo+hi)/2;if(ok(mid))lo=mid;else hi=mid}
      fs=lo;
    }
    engState.tooSmall=fs<minFs*0.999;
    fs=Math.max(minFs,fs);
    boxEl.style.fontSize=fs+'px';
    spans.forEach(function(s,i){
      if(i<N){var t=pos+(i-(N-1)/2)*pitch*fs/areaH;s.style.top=(t*100)+'%';s.hidden=false}
      else{s.hidden=true}
    });
  }
  var emojiRe;
  try{emojiRe=new RegExp('[\\p{Extended_Pictographic}\\u{FE0E}\\u{FE0F}\\u{200D}\\u{20E3}\\u{1F1E6}-\\u{1F1FF}\\u{1F3FB}-\\u{1F3FF}\\u{E0020}-\\u{E007F}]','gu')}
  catch(e){emojiRe=/[\uD83C-\uDBFF][\uDC00-\uDFFF]|[☀-➿]|[︎️‍⃣]/g}
  function stripEmoji(s){return String(s).replace(emojiRe,'')}
  var engMsgEl=$('[data-bjp-eng-msg]'),engMsgTimer=null;
  function engMsg(t){
    if(!engMsgEl)return;
    engMsgEl.textContent=t;engMsgEl.hidden=false;
    clearTimeout(engMsgTimer);engMsgTimer=setTimeout(function(){engMsgEl.hidden=true},3500);
  }
  // The character limit for line i (0-based) of an n-line engraving: the single-line
  // limit when there is one line, otherwise the charm's per-line limits top to bottom.
  function engLimit(i,n){return n<=1?engCfg.one:(engCfg.limits[Math.min(i,engCfg.limits.length-1)]||8)}
  // Turns what was typed into the lines that will be engraved. Explicit returns
  // are kept; a line that is over its limit wraps at a space onto the next line.
  function engLayout(text){
    var raw=String(text||'').replace(/\r/g,'').split('\n').map(function(s){return s.replace(/[ \t]+/g,' ').trim()});
    while(raw.length&&!raw[raw.length-1])raw.pop();
    raw=raw.map(function(s){return s});
    if(!raw.filter(Boolean).length)return {lines:[],over:false,tooMany:false};
    var L=engCfg.lines,one=engCfg.one,out=[];
    if(raw.length===1&&raw[0].length<=one)return {lines:[raw[0]],over:false,tooMany:false};
    if(L<=1)return {lines:[raw[0]],over:raw[0].length>one,tooMany:raw.length>1};
    raw.forEach(function(ln){
      var cur='';
      ln.split(' ').forEach(function(w){
        if(!w)return;
        var t=cur?cur+' '+w:w,lim=engLimit(out.length,2);
        if(t.length<=lim)cur=t;else{if(cur)out.push(cur);cur=w}
      });
      out.push(cur);
    });
    var n=out.length;
    return {lines:out,over:out.some(function(l,i){return l.length>engLimit(i,n)}),tooMany:n>L};
  }
  // Countdown of what is left on each line. Red only when the words physically
  // cannot be engraved (smaller than the charm's smallest size) or there are too many lines.
  function engLineName(i,n){
    if(n<=1)return '';
    if(n===2)return i===0?'Top line':'Bottom line';
    return i===n-1?'Bottom line':'Line '+(i+1);
  }
  function engCounter(lay){
    var c=$('[data-bjp-counter]');if(!c||!engMain)return;
    var n=lay.lines.length;
    if(n<=1){var left=engCfg.one-((lay.lines[0]||'').length);c.textContent=left+' left'}
    else{c.textContent=lay.lines.map(function(l,i){return engLineName(i,n)+': '+Math.max(0,engLimit(i,n)-l.length)+' left'}).join(' · ')}
    c.classList.toggle('is-over',lay.tooMany||engState.tooSmall);
  }
  // The first line over its limit, or -1. Adding a line can push a line already
  // typed over its limit (the top of a heart takes more than the bottom).
  function engOverLine(lay){var n=lay.lines.length;for(var i=0;i<n;i++)if(lay.lines[i].length>engLimit(i,n))return i;return -1}
  function engLimitNote(i,n){
    var ref=n===2?(i===0?'the top line':'the bottom line'):(i===n-1?'the bottom line':'line '+(i+1));
    return 'With '+n+' lines, '+ref+' takes up to '+engLimit(i,n)+' characters.';
  }
  function engProblem(lay){
    if(lay.tooMany)return 'This charm takes up to '+engCfg.lines+' line'+(engCfg.lines>1?'s':'')+'.';
    if(engState.tooSmall)return "That's a little long to engrave on this charm. Try fewer letters"+(engCfg.lines>1&&lay.lines.length<engCfg.lines?', or put part of it on a new line':'')+'.';
    return '';
  }
  function updateEngraving(){
    var lay=null;
    if(engMain){
      lay=engLayout(engMain.value);
      engMain.rows=Math.min(Math.max(1,(engMain.value.match(/\n/g)||[]).length+1),Math.max(1,engCfg.lines));
    }
    fitEngraving();
    if(lay){
      engCounter(lay);
      // Say why the countdown has gone red as they type, not only on Add to bag.
      var problem=engProblem(lay);if(problem)engMsg(problem);
    }
  }
  if(engMain){
    engMain.addEventListener('keydown',function(e){
      if(e.key!=='Enter')return;
      var v=engMain.value,n=(v.match(/\n/g)||[]).length+1;
      if(n>=engCfg.lines){e.preventDefault();if(engCfg.lines>1)engMsg('This charm takes up to '+engCfg.lines+' lines.');return}
      // Refuse the return if a line already typed would be too long once there is
      // a line below it, and say which line and why.
      var s=engMain.selectionStart;if(s==null)s=v.length;
      var test=engLayout(v.slice(0,s)+'\n'+(v.slice(s)||'x')),bad=engOverLine(test);
      if(bad>=0){e.preventDefault();engMsg(engLimitNote(bad,test.lines.length))}
    });
  }
  root.addEventListener('input',function(e){
    if(!e.target.matches('[data-bjp-engraving-input]'))return;
    if(e.target.maxLength===1){e.target.value=e.target.value.toUpperCase();}
    else{
      var clean=stripEmoji(e.target.value);
      if(clean!==e.target.value){
        var pos=(e.target.selectionStart||clean.length)-(e.target.value.length-clean.length);
        e.target.value=clean;
        try{e.target.setSelectionRange(pos,pos)}catch(x){}
        engMsg("Sorry, we can't engrave emojis.");
      }
      // Hard stop: anything over a line's limit (or over the line count) is not
      // accepted — the text is cut back until it fits, with a short note.
      if(e.target===engMain&&eng){
        var lay=engLayout(engMain.value);
        if(lay.over||lay.tooMany){
          var v=engMain.value,bad=lay.over?engOverLine(lay):-1,nIn=lay.lines.length;
          while(v.length&&(lay.over||lay.tooMany)){v=v.slice(0,-1);lay=engLayout(v)}
          engMain.value=v;
          try{engMain.setSelectionRange(v.length,v.length)}catch(x){}
          if(bad>=0&&bad<nIn-1)engMsg(engLimitNote(bad,nIn));
          else engMsg(lay.lines.length>1?"That's the most that fits on this line.":"That's the most that fits on one line"+(engCfg.lines>1?' — press return for a new line.':'.'));
        }
      }
    }
    updateEngraving();
    // Clear the "Please enter…" message as soon as they start typing.
    var engErr=$('[data-bjp-engraving-error]');if(engErr&&e.target.value.trim())engErr.hidden=true;
  });
  function fitEngraving(){
    if(!eng)return;
    var size,fs,minFs;
    if(eng.getAttribute('data-mode')==='discs'){
      // One disc photo per initial box, the letter drawn on each.
      var holder=$('[data-bjp-engrave-discs]',eng);if(!holder)return;
      var inputs=$$('[data-bjp-engraving-input]');
      var discs=$$('.bjp-engrave__disc',holder);
      if(discs.length!==inputs.length){
        holder.innerHTML='';
        inputs.forEach(function(){
          var d=document.createElement('span');d.className='bjp-engrave__disc';
          var im=document.createElement('img');im.src=eng.getAttribute('data-img');im.alt='';im.width=720;im.height=720;im.loading='lazy';
          var t=document.createElement('span');t.className='bjp-engrave__text';t.setAttribute('data-bjp-engrave-text','');
          var l=document.createElement('span');l.setAttribute('data-bjp-engrave-line','');t.appendChild(l);
          d.appendChild(im);d.appendChild(t);holder.appendChild(d);
        });
        discs=$$('.bjp-engrave__disc',holder);
      }
      var any=false;
      discs.forEach(function(d,i){
        var boxEl=$('[data-bjp-engrave-text]',d),ln=$('[data-bjp-engrave-line]',d),ch=(inputs[i]&&inputs[i].value||'').trim().toUpperCase();
        ln.textContent=ch;if(ch)any=true;
        size=d.clientWidth;if(!size||!ch){ln.hidden=true;return}
        engPlace(boxEl,[ln],[ch],size);
      });
      eng.classList.toggle('has-text',any);
      return;
    }
    var charm=$('.bjp-engrave__charm',eng),boxEl=$('[data-bjp-engrave-text]',eng),spans=$$('[data-bjp-engrave-line]',eng);
    if(!charm||!boxEl||!spans.length)return;
    var lay=engLayout(engMain?engMain.value:''),lines=lay.lines.slice(0,spans.length);
    spans.forEach(function(s,i){s.textContent=lines[i]||'';s.hidden=!lines[i]});
    eng.classList.toggle('has-text',lines.length>0);
    size=charm.clientWidth;
    if(!size||!lines.length){engState.tooSmall=false;return}
    engPlace(boxEl,spans,lines,size);
  }
  if(eng){
    updateEngraving();
    window.addEventListener('resize',fitEngraving);
    if(document.fonts&&document.fonts.addEventListener)document.fonts.addEventListener('loadingdone',fitEngraving);
  }

  /* ---------- gift card recipient (Shopify send-to-recipient) ---------- */
  var recipToggle=$('[data-bjp-recip-toggle]'),
      recipFields=$('[data-bjp-recip-fields]'),
      recipOffset=$('[data-bjp-recip-offset]'),
      recipDate=$('[data-bjp-recip-date]');
  if(recipToggle){
    if(recipDate){
      var pad=function(n){return (n<10?'0':'')+n};
      var fmt=function(d){return d.getFullYear()+'-'+pad(d.getMonth()+1)+'-'+pad(d.getDate())};
      var today=new Date(),maxd=new Date();maxd.setDate(maxd.getDate()+90);
      recipDate.min=fmt(today);recipDate.max=fmt(maxd);
    }
    if(recipOffset)recipOffset.value=String(new Date().getTimezoneOffset());
    var setRecip=function(on){
      if(recipFields)recipFields.hidden=!on;
      $$('[data-bjp-recip-input]').forEach(function(i){i.disabled=!on});
      if(recipOffset)recipOffset.disabled=!on;
      var err=$('[data-bjp-recip-error]');if(err&&!on)err.hidden=true;
    };
    recipToggle.addEventListener('change',function(){setRecip(recipToggle.checked)});
    var rc=$('[data-bjp-recip-counter]');
    root.addEventListener('input',function(e){
      if(rc&&e.target.matches('[data-bjp-recip-input="Message"]'))rc.textContent=e.target.value.length+'/200';
    });
  }
  function validateRecipient(){
    if(!recipToggle||!recipToggle.checked)return true;
    var email=$('[data-bjp-recip-email]'),err=$('[data-bjp-recip-error]');
    var val=(email&&email.value.trim())||'';
    if(!val||val.indexOf('@')<1||val.lastIndexOf('.')<val.indexOf('@')){
      if(err){err.textContent="Please enter the recipient's email address.";err.hidden=false}
      if(email)email.focus();
      return false;
    }
    if(err)err.hidden=true;
    return true;
  }

  /* ---------- cart plumbing ---------- */
  function cartConfig(){
    try{return JSON.parse(document.getElementById('cart-config').innerHTML||'{}')}catch(e){return {}}
  }
  function refreshDrawer(){
    return fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
      try{setCart(cart)}catch(e){}
      var cfg=cartConfig();
      try{
        Shopify.theme.ajaxCart.updateView(cfg,cart);
        Shopify.theme.ajaxCart.showDrawer(cfg);
        if(cfg.cart_action!=='drawer')Shopify.theme.ajaxCart.showModal(cfg);
      }catch(e){window.location.href='/cart'}
    });
  }
  function addItems(items){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){if(!r.ok)return r.json().then(function(j){throw j});return r.json()});
  }

  /* ---------- engraving validation ---------- */
  function validateEngraving(){
    var wrap=$('[data-bjp-engraving]');if(!wrap)return true;
    var err=$('[data-bjp-engraving-error]',wrap);var ok=true;
    if(engMain){
      var lay=engLayout(engMain.value),problem=lay.lines.length?engProblem(lay):'Please enter your engraving.';
      if(problem){engMain.focus();err.textContent=problem;err.hidden=false;return false}
      if(err)err.hidden=true;
      return true;
    }
    $$('[data-bjp-engraving-input]',wrap).forEach(function(inp){
      if(!inp.value.trim()&&ok){ok=false;inp.focus();
        err.textContent=inp.maxLength===1?'Please enter the initial for each disc.':'Please enter your engraving.';
        err.hidden=false;}
    });
    if(ok&&err)err.hidden=true;
    return ok;
  }

  /* ---------- Klaviyo back in stock ---------- */
  function triggerBIS(){
    var t=document.querySelector('a.klaviyo-bis-trigger');
    if(t){t.click();return}
    var tries=0,iv=setInterval(function(){
      var el=document.querySelector('a.klaviyo-bis-trigger');
      if(el){clearInterval(iv);el.click()}
      else if(++tries>10){clearInterval(iv);window.location.href='/pages/contact'}
    },300);
  }

  /* ---------- main ATC ---------- */
  var form=$('[data-bjp-form]');
  function mainProperties(){
    var props={};
    if(engMain){
      // The lines as they will be engraved, one property each so nothing is guessed.
      var lay=engLayout(stripEmoji(engMain.value));
      if(lay.lines.length===1)props['Engraving']=lay.lines[0];
      else lay.lines.forEach(function(l,i){props['Engraving (line '+(i+1)+')']=l});
    }
    $$('[data-bjp-engraving-input]').forEach(function(inp){
      if(inp.hasAttribute('data-bjp-eng-main'))return;
      var m=inp.name.match(/^properties\[(.+)\]$/);
      var val=stripEmoji(inp.value).trim();
      if(m&&val)props[m[1]]=val;
    });
    if(recipToggle&&recipToggle.checked){
      props['__shopify_send_gift_card_to_recipient']='on';
      $$('[data-bjp-recip-input]').forEach(function(inp){
        var key=inp.getAttribute('data-bjp-recip-input');
        if(key&&inp.value.trim())props[key]=inp.value.trim();
      });
      props['__shopify_offset']=String(new Date().getTimezoneOffset());
    }
    return props;
  }
  function submitMain(){
    var v=currentVariant();if(!v)return;
    if(!v.available){triggerBIS();return}
    if(!validateEngraving())return;
    if(!validateRecipient())return;
    atc.disabled=true;var old=atcLabel.textContent;atcLabel.textContent='Adding…';
    addItems([{id:v.id,quantity:1,properties:mainProperties()}])
      .then(refreshDrawer)
      .then(function(){atcLabel.textContent=old;atc.disabled=false})
      .catch(function(e){atcLabel.textContent=old;atc.disabled=false;
        var err=$('[data-bjp-recip-error]')||$('[data-bjp-engraving-error]');var msg=(e&&e.description)||'Sorry, that could not be added — please try again.';
        if(err){err.textContent=msg;err.hidden=false}else{alert(msg)}});
  }
  form.addEventListener('submit',function(e){e.preventDefault();submitMain()});
  if(stickyAtc)stickyAtc.addEventListener('click',submitMain);

  /* ---------- sticky bar visibility ---------- */
  var sticky=$('[data-bjp-sticky]');
  if(sticky&&'IntersectionObserver' in window){
    var atcOff=false,footerOn=false;
    function setSticky(){
      var vis=atcOff&&!footerOn;
      sticky.classList.toggle('is-visible',vis);
      sticky.setAttribute('aria-hidden',vis?'false':'true');
    }
    new IntersectionObserver(function(en){
      atcOff=!en[0].isIntersecting&&en[0].boundingClientRect.top<0;setSticky();
    },{threshold:0}).observe(atc);
    var footer=document.querySelector('footer')||document.querySelector('[id*="footer"]');
    if(footer){
      new IntersectionObserver(function(en){footerOn=en[0].isIntersecting;setSticky()},{threshold:0.05}).observe(footer);
    }
  }

  /* ---------- complete your stack ---------- */
  var rows=$$('[data-bjp-stackrow]');
  var rowCache=new WeakMap();
  function rowData(row){
    if(!rowCache.has(row))rowCache.set(row,JSON.parse($('[data-bjp-stackdata]',row).textContent));
    return rowCache.get(row);
  }
  function colourVariants(d,val){
    var m=d.variants.filter(function(v){return v.options[d.colour_pos-1]===val});
    return m.filter(function(v){return v.available}).concat(m.filter(function(v){return !v.available}));
  }
  function chipAvailable(d,val){return colourVariants(d,val).some(function(v){return v.available})}
  function rowSelectedVariant(row){
    var d=rowData(row);
    if(d.colour_pos>0){
      var chip=$('.bjp-stack__chip.is-selected',row);
      if(!chip)return null;
      return colourVariants(d,chip.dataset.value)[0]||null;
    }
    return d.variants.filter(function(v){return v.available})[0]||d.variants[0]||null;
  }
  function metalOf(val){val=(val||'').toLowerCase();
    if(val.indexOf('rose')>-1)return 'rose';if(val.indexOf('gold')>-1)return 'gold';if(val.indexOf('silver')>-1)return 'silver';return ''}
  function syncRowVisual(row){
    var v=rowSelectedVariant(row);
    var pe=$('[data-bjp-stackprice]',row);
    if(v&&pe)pe.textContent=money(v.price);
    var img=$('[data-bjp-stackimg]',row);
    if(v&&img&&v.image&&img.getAttribute('src')!==v.image){img.removeAttribute('srcset');img.src=v.image}
    var sold=!v||!v.available;
    var btn=$('[data-bjp-stackadd]',row);
    if(btn&&!btn.dataset.adding){
      btn.disabled=sold;
      btn.classList.toggle('is-soldout',sold);
      btn.textContent=sold?'Sold out':'+ Add';
    }
    var flag=$('[data-bjp-soldflag]',row);
    if(flag)flag.hidden=!sold;
    var chip=$('.bjp-stack__chip.is-selected',row),nameEl=$('[data-bjp-stackchipname]',row);
    if(nameEl)nameEl.textContent=chip?chip.dataset.value:'';
    $$('.bjp-stack__chip',row).forEach(function(c){c.setAttribute('aria-checked',c.classList.contains('is-selected')?'true':'false')});
  }
  function updateStackMatch(){
    var cpos=optionNames.indexOf('Colour');
    var mainMetal=cpos>-1?metalOf(selected[cpos]):'';
    rows.forEach(function(row){
      var d=rowData(row);
      if(d.colour_pos>0){
        var chips=$$('.bjp-stack__chip',row);
        chips.forEach(function(c){c.classList.toggle('is-oos',!chipAvailable(d,c.dataset.value))});
        if(!row.dataset.userPicked){
          // Same metal as the main piece if it's in stock, otherwise the
          // first colour that is — never default to a sold-out colour.
          var pick=null;
          chips.forEach(function(c){if(!pick&&metalOf(c.dataset.value)===mainMetal&&chipAvailable(d,c.dataset.value))pick=c});
          chips.forEach(function(c){if(!pick&&chipAvailable(d,c.dataset.value))pick=c});
          if(!pick)chips.forEach(function(c){if(!pick&&metalOf(c.dataset.value)===mainMetal)pick=c});
          if(!pick)pick=chips[0];
          chips.forEach(function(c){c.classList.toggle('is-selected',c===pick)});
        }
      }
      syncRowVisual(row);
    });
  }
  // Private cart attribute so orders that used this block can be counted in
  // Shopify admin (same idea as the bag rail's _cart_upsell).
  function markPairs(){
    return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{'_pdp_pairs':'yes'}})}).catch(function(){});
  }
  function bindRow(row){
    $$('.bjp-stack__chip',row).forEach(function(chip){
      chip.addEventListener('click',function(){
        row.dataset.userPicked='1';
        $$('.bjp-stack__chip',row).forEach(function(c){c.classList.toggle('is-selected',c===chip)});
        syncRowVisual(row);renderStackNudge();
      });
    });
    var btn=$('[data-bjp-stackadd]',row);
    btn.addEventListener('click',function(){
      var v=rowSelectedVariant(row);if(!v||!v.available)return;
      btn.disabled=true;btn.dataset.adding='1';
      addItems([{id:v.id,quantity:1}]).then(markPairs).then(refreshDrawer).then(function(){
        btn.classList.add('is-added');btn.textContent='✓ Added';
        setTimeout(function(){btn.classList.remove('is-added');delete btn.dataset.adding;btn.disabled=false;syncRowVisual(row)},2200);
      }).catch(function(){delete btn.dataset.adding;btn.disabled=false;syncRowVisual(row)});
    });
  }
  rows.forEach(bindRow);
  // One more piece usually clears the £75 free-delivery line (singles are
  // £36–£65). Only say so when it's true for every piece shown, counting
  // this bracelet (and anything already in the bag), and name this bracelet
  // so it's clear both are needed.
  var stackSub=$('[data-bjp-stack-sub]');
  function renderStackNudge(){
    if(!stackSub||!rows.length)return;
    var cur=currentVariant(),rem=FD-orderBase(cur&&cur.available?cur:null);
    var prices=rows.map(function(row){var v=rowSelectedVariant(row);return v&&v.available?v.price:null}).filter(function(p){return p!==null});
    if(cur&&cur.available&&rem>0&&prices.length&&Math.min.apply(null,prices)>=rem){
      stackSub.innerHTML='';
      stackSub.appendChild(document.createTextNode('Buy any one of these with your '+product.title+' and get '));
      var st=document.createElement('strong');st.textContent='free UK delivery';stackSub.appendChild(st);
      stackSub.appendChild(document.createTextNode('.'));
    }else{
      stackSub.textContent=stackSub.getAttribute('data-default')||'';
    }
  }
  // Swap in Shopify's purchase-based picks (orders Apr–Oct 2026: they matched
  // what multi-bracelet buyers actually bought 44% of the time, the manual
  // pairings 25%; a 4th pick added 17 more matches of 485, a 5th 10 more).
  // Leaves the manual ones alone if fewer than 2 come back or
  // the shopper has already started using the block.
  (function smartPairs(){
    var wrap=$('[data-bjp-stack]');if(!wrap)return;
    var url=wrap.getAttribute('data-bjp-pairs-url');if(!url)return;
    fetch(url,{credentials:'same-origin'}).then(function(r){return r.ok?r.text():''}).then(function(html){
      if(!html)return;
      var tmp=new DOMParser().parseFromString(html,'text/html');
      var fresh=Array.prototype.slice.call(tmp.querySelectorAll('[data-bjp-stackrow]'));
      fresh=fresh.slice(0,parseInt(wrap.getAttribute('data-bjp-pairs-max')||'4',10)||4);
      if(!fresh.length||(rows.length&&fresh.length<2))return;
      if(rows.some(function(r){return r.dataset.userPicked||$('[data-bjp-stackadd]',r).dataset.adding}))return;
      var cards=$('[data-bjp-stack-cards]',wrap);if(!cards)return;
      cards.innerHTML='';fresh.forEach(function(r){cards.appendChild(r)});
      rows=fresh;rowCache=new WeakMap();rows.forEach(bindRow);
      wrap.hidden=false;
      updateStackMatch();renderStackNudge();
    }).catch(function(){});
  })();

  /* ---------- reviews (Judge.me public API) ---------- */
  (function reviews(){
    var list=$('[data-bjp-reviews-list]');if(!list)return;
    var domain=root.dataset.shopDomain,pid=root.dataset.productId;
    var storeMode=parseInt(root.dataset.ratingCount||'0',10)===0;
    var PAGE=3, MAXTOTAL=storeMode?15:24;
    function shortName(full){
      var parts=(full||'').trim().split(/\s+/);
      if(parts.length<2)return parts[0]||'';
      return parts[0]+' '+parts[1].charAt(0).toUpperCase()+'.';
    }
    function parseReviews(html){
      var tmp=new DOMParser().parseFromString(html||'','text/html');
      return Array.prototype.slice.call(tmp.querySelectorAll('.jdgm-rev')).map(function(el){
        function txt(s){var n=el.querySelector(s);return n?n.textContent.trim():''}
        var rating=el.querySelector('.jdgm-rev__rating');
        var tsEl=el.querySelector('.jdgm-rev__timestamp');
        var ts=0;
        if(tsEl){var raw=tsEl.getAttribute('data-content')||'';ts=Date.parse(raw)||0}
        return{author:shortName(txt('.jdgm-rev__author')),verified:el.getAttribute('data-verified-buyer')==='true',
          rating:rating?parseInt(rating.getAttribute('data-score')||'5',10):5,
          title:txt('.jdgm-rev__title'),body:txt('.jdgm-rev__body'),ts:ts};
      }).filter(function(r){return r.body||r.title});
    }
    function fetchFor(id,perPage){
      var u='https://judge.me/reviews/reviews_for_widget?url='+domain+'&shop_domain='+domain+'&platform=shopify&page=1&per_page='+perPage+'&product_id='+id;
      return fetch(u).then(function(r){return r.json()}).then(function(d){return parseReviews(d.html)}).catch(function(){return []});
    }
    var job;
    if(storeMode){
      var ids=(root.dataset.reviewSources||'').split(',').filter(Boolean);
      if(!ids.length)ids=rows.map(function(row){return rowData(row).id}).slice(0,3);
      if(!ids.length){var sec0=document.getElementById('bjp-reviews');if(sec0)sec0.style.display='none';return}
      job=Promise.all(ids.map(function(id){return fetchFor(id,10)})).then(function(arrs){
        return [].concat.apply([],arrs).sort(function(a,b){return b.ts-a.ts}).slice(0,MAXTOTAL);
      });
    }else{
      job=fetchFor(pid,MAXTOTAL);
    }
    job.then(function(revs){
      if(!revs.length){
        if(storeMode){var sec=document.getElementById('bjp-reviews');if(sec)sec.style.display='none';}
        return;
      }
      var visible=0;
      function card(r){
        var d=document.createElement('div');d.className='bjp-review';
        var stars='★★★★★'.slice(0,r.rating)+'☆☆☆☆☆'.slice(0,5-r.rating);
        d.innerHTML='<div class="bjp-review__top"><span class="bjp-review__stars"></span><span class="bjp-review__meta"></span></div>'+
          '<div class="bjp-review__title"></div><div class="bjp-review__body"></div>';
        d.querySelector('.bjp-review__stars').textContent=stars;
        var meta=d.querySelector('.bjp-review__meta');meta.textContent=r.author;
        // Judge.me marks reviews tied to a real order; say so (verified-buyer
        // labels lift purchase likelihood — Spiegel Research Center).
        if(r.verified){var vb=document.createElement('span');vb.className='bjp-review__verified';vb.textContent='Verified buyer';meta.appendChild(vb)}
        var t=d.querySelector('.bjp-review__title');t.textContent=r.title;if(!r.title)t.remove();
        d.querySelector('.bjp-review__body').textContent=r.body;
        return d;
      }
      var more=$('[data-bjp-reviews-more]'),less=$('[data-bjp-reviews-less]');
      if(more)more.removeAttribute('hidden');
      if(less)less.removeAttribute('hidden');
      function show(el,on){if(el)el.classList.toggle('is-shown',!!on)}
      function renderTo(n){
        n=Math.max(PAGE,Math.min(n,revs.length));
        list.innerHTML='';
        revs.slice(0,n).forEach(function(r){list.appendChild(card(r))});
        visible=n;
        show(more,visible<revs.length);
        show(less,visible>PAGE);
      }
      renderTo(PAGE);
      if(more)more.addEventListener('click',function(){renderTo(visible+PAGE)});
      if(less)less.addEventListener('click',function(){
        renderTo(PAGE);
        var head=document.getElementById('bjp-reviews');if(head)head.scrollIntoView({behavior:'smooth',block:'start'});
      });
    });
  })();

  /* ---------- boot ---------- */
  render();
})();
